import React, {useRef, useState, useEffect} from "react";
import {observer, inject} from "mobx-react";

import {Formik, Form, useField} from 'formik';
import * as Yup from 'yup';
import {TextInput, CheckboxInput, TextLabel} from "@components/Form/FormFields";
import axios from "axios";


@inject("store")
@observer
export default class CustomerUsers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sentTo: [],
            users: []
        };
    }

    componentDidMount() {
        //const customerId = this.props.store.navigation.getCustomerId();

        this.props.store.beriksson.customerAccountUsers().then(res => {
            this.setState({users: res})
        })
    }

    toggleAdmin(user) {
        const member = this.state.users.find(x => x.MemberEmail === user.MemberEmail)

        this.props.store.beriksson.customerAccountUserUpdate({...member, MemberIsAdmin: !member.MemberIsAdmin}).then(res => {
            this.setState({users: res})
        })
    }

    setRole(e, user) {
        let sendInvite = false;
        if (user.MemberCustomerRole.indexOf("pending") > -1 && e.target.value.indexOf("pending") === -1) {
            sendInvite = confirm("Vill du även skicka en inbjudan?")
        }

        const member = this.state.users.find(x => x.MemberEmail === user.MemberEmail)

        this.props.store.beriksson.customerAccountUserUpdate({...member, MemberCustomerRole: e.target.value, SendInvite: sendInvite}).then(res => {
            if (sendInvite) {
                const sentTo = [...this.state.sentTo];
                if (sentTo.findIndex(x => x === member.MemberEmail) === -1) {
                    sentTo.push(member.MemberEmail);
                    this.setState({sentTo: sentTo, users: res})
                    this.props.store.navigation.toast("Roll uppdaterad och inbjudan skickad.");
                }
            } else {
                this.setState({users: res})
                this.props.store.navigation.toast("Roll uppdaterad");
            }
        })
    }


    sendInvite(memberId, memberEmail, message) {
        const sentTo = [...this.state.sentTo];

        if (sentTo.findIndex(x => x === memberEmail) === -1) {
            sentTo.push(memberEmail);
            this.setState({sentTo: sentTo})
        }


        this.props.store.beriksson.inviteUser(memberId, memberEmail, message).then(
            res => {
                this.props.store.navigation.toast("Inbjudan skickades");
            },
            error => {
                this.props.store.navigation.toastError("Inbjudan kunde inte skickas.")
            });

    }

    async updateEmail(memberId, email) {
        try
        {
            await this.props.store.beriksson.customerAccountEmailUpdate({ MemberId: memberId, Email: email });
            this.props.store.navigation.toast("E-postadress uppdaterad!");
            var users = await this.props.store.beriksson.customerAccountUsers();
            this.setState({users: users});
        }
        catch(ex)
        {
            this.props.store.navigation.toastError("Kunde inte uppdatera e-postadress.");
        }
    }

    render() {
        if (!this.props.store.navigation.getCustomerId()) {
            return <div>Error: No customer choosen</div>;
        }

        return (
            <div
            >
                <div className="row">
                    <div className="col-md-8 ">
                        <h4 className="text-normal pt-4">Användare</h4>
                        <hr className="mb-3"/>
                        <div className={"customer-account-card"}>
                            {this.state.users.map(user => {

                                const sendDisabled = (user.MemberCustomerRole.indexOf('pending') > -1) || (this.state.sentTo && this.state.sentTo.findIndex(x => x === user.MemberEmail) > -1);

                                return (
                                    <div
                                        key={"user_" + user.MemberEmail}
                                        className={"customer-account-address"}
                                    >
                                        <div className={"form-group"}>
                                            <div className={"col-sm-12"}>
                                                <h5>{user.MemberFirstName} {user.MemberLastName}</h5>
                                            </div>
                                            {/*<div className="custom-control custom-checkbox">*/}
                                            {/*    <input className="custom-control-input" type="checkbox" checked={user.MemberIsAdmin} readOnly={true} disabled={user.Me}/>*/}
                                            {/*    <label className="custom-control-label" htmlFor={user.MemberEmail} onClick={() => this.toggleAdmin(user)}>*/}
                                            {/*        Administratör*/}
                                            {/*    </label>*/}
                                            {/*</div>*/}
                                            
                                                
                                            {
                                                this.props.store.account.inRole("icom-admin")
                                                && UpdateEmailForm({ memberId: user.MemberId, email: user.MemberEmail, onSubmit: this.updateEmail.bind(this) })
                                                || <div className={"col-sm-12"} name={"user-" + user.MemberId + "-email"}>{user.MemberEmail}</div>
                                            }
                                                
                                            <div className={"form-group col-sm-12"}>
                                                <label htmlFor={"user-" + user.MemberId}>Roll</label>
                                                <select className={"form-control"} name={"user-" + user.MemberId}
                                                        disabled={user.Me}
                                                        onChange={(e) => this.setRole(e, user)} value={user.MemberCustomerRole}>
                                                    {Object.keys(user.AvailableRoles).map(ct => {
                                                        return (<option value={ct} key={ct}>{user.AvailableRoles[ct]}</option>)
                                                    })}
                                                </select>
                                            </div>
                                            {user.MemberCustomerRole.indexOf("pending") === -1 
                                                && <div className={"form-group col-sm-12"}>
                                                {
                                                    !user.Me && <button 
                                                        disabled={sendDisabled} 
                                                        className="btn btn-success btn-sm"
                                                        onClick={() => this.sendInvite(user.MemberId, user.MemberEmail, "")}>Skicka inbjudan på nytt</button>
                                                }
                                                </div>
                                            }
                                        </div>
                                        
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className={"col-md-4"}>
                        {/*<h4 className="text-normal pt-4">Bjud in ny användare</h4>*/}
                        {/*<hr className="mb-3"/>*/}
                        {/*<div className={"customer-account-invite"}>*/}
                        {/*    <InviteForm/>*/}
                        {/*</div>*/}
                    </div>
                </div>

            </div>);

    }
}

const UpdateEmailForm = ({ email, memberId, onSubmit }) => {
    return (
        <Formik
            validateOnMount={true}
            enableReinitialize={true}
            initialValues={{
                memeberId: memberId,
                email: email
            }}
            validateOnMount={true}
            isInitialValid={false}
            validationSchema={Yup.object({
                email : Yup.string().required().email()
            })}
            onSubmit={(values, actions) => {
                onSubmit(memberId, values.email).then(() => actions.setSubmitting(false));
            }}
        >
            {
                (props) => {
                    return (<form onSubmit={props.handleSubmit} className={"col-sm-12"}>
                        <div className={"row"}>
                            <div className={"col-sm-9"}>
                                <input 
                                    className={"form-control"}
                                    type="email" 
                                    onChange={props.handleChange} 
                                    value={props.values.email}
                                    name="email"/>
                            </div>
                            <div className={"col-sm-3 pl-sm-0"}>
                                <button className="btn btn-success"
                                    type="submit"
                                    disabled={props.isSubmitting || !props.isValid}>Spara
                                </button>
                            </div>
                        </div>
                    </form>)
                }
            }
        </Formik>
    );
}


const EditMemberForm = ({...props}) => {
    return (
        <Formik
            validateOnMount={true}
            enableReinitialize={true}
            initialValues={{
                cultureCode: props.cultureCode,
                nodeId: props.nodeId,

                memberIsAdmin: props.member.MemberIsAdmin
            }}
            validationSchema={Yup.object({})}
            //onSubmit={onSubmitWithReCAPTCHA}
            onSubmit={(values, {setSubmitting}) => {
                // props.berikssonStore.customerAccountMemberInvite(values).then(res => {
                //     console.log("berikssonStore.customerUpdate() => ", res)
                // })
                alert(JSON.stringify(values, null, 2));

                setSubmitting(false);
            }}


        >
            {({touched, values, setSubmitting, isSubmitting, handleChange, setFieldValue, isValid}) => {
                //  noValidate
                return <Form>

                    <div className={"row"}>
                        <div className={"col-sm-12"}>
                            <CheckboxInput
                                id={"memberIsAdmin" + "_" + props.member.MemberEmail}
                                name="memberIsAdmin"

                            >
                                Administratatör
                            </CheckboxInput>
                        </div>
                    </div>

                    {touched.memberIsAdmin && <button className="btn btn-success"
                                                      type="submit"
                                                      disabled={isSubmitting || !isValid}>Spara
                    </button>}

                </Form>
            }
            }
        </Formik>
    );
};


const InviteForm = ({...props}) => {
    return (
        <Formik
            validateOnMount={true}
            enableReinitialize={true}
            initialValues={{
                cultureCode: props.cultureCode,
                nodeId: props.nodeId,
                memberEmail: '',
            }}
            validationSchema={Yup.object({

                memberEmail: Yup.string()
                    .email('Ogiltig epostadress')
                    .required('Måste anges'),
            })}
            //onSubmit={onSubmitWithReCAPTCHA}
            onSubmit={(values, {setSubmitting}) => {
                // props.berikssonStore.customerAccountMemberInvite(values).then(res => {
                //     console.log("berikssonStore.customerUpdate() => ", res)
                // })
                alert(JSON.stringify(values, null, 2));

                setSubmitting(false);

            }}

        >
            {({values, setSubmitting, isSubmitting, handleBlur, setFieldValue, isValid}) => {
                //  noValidate
                return <Form>

                    <div className={"row"}>
                        <div className={"col-sm-12"}>
                            <TextInput
                                label="E-postadress "
                                name="memberEmail"
                                type="text"
                            /></div>

                    </div>

                    <button className="btn btn-success"
                            type="submit"
                            disabled={isSubmitting || !isValid}>Skicka inbjudan
                    </button>

                </Form>
            }
            }
        </Formik>
    );
};
